import React,{useEffect, useState}from 'react'
import { useNavigate} from 'react-router-dom'

export const Favourite = () => {
const [cocktail,setCocktail]=useState([])

 const navigate = useNavigate();

//list all saved cocktail
const fetchDatabase = async()=>{
  const cocktailAPI = `https://cokctail.herokuapp.com/drinks` 
  const response = await fetch(cocktailAPI);
  const data = await response.json();
  // console.log(data.payload,'a')
  setCocktail(data.payload)
}

useEffect(()=>{
  fetchDatabase();
},[])

const deleteCocktail = async(id)=>{
  const cocktailAPI = `https://cokctail.herokuapp.com/drinks/${id}` 
  const response = await fetch(cocktailAPI,{
    method:'DELETE'
  });
  const data = await response.json()
  console.log(data.payload)
  alert('Cocktail removed ✅')
  navigate("/")
}

  return (
    <div className=' grid lg:grid-cols-3 md:grid-cols-1 gap-5 m-1'>
      {cocktail?.map((item,idx)=>{
          return (
            <div key={idx} >
              <div>
                  <h1 className='text-5xl'>{item.name}</h1> 
                  <img alt='-' src={item.image} className='card-container rounded-xl border-none cursor-pointer'/>
              </div>
               <div>
                <h5 className='text-5xl'>{item.name} Ingredients</h5>
                <hr/>
                <br/>
                <div style={{fontSize:'70%',fontFamily:'fantasy'}}>
                  <ul className='text-3xl'>
                    <li >{item.ingridients}</li>
                  </ul>
                </div>
                <br/>
                <div className='text-3xl'>
                  <p >{item.instructions}</p>
                </div>
              </div> 
                 <hr/>
                 <hr/>
                 <hr/>  
                 <button className='text-3xl' onClick={()=>deleteCocktail(item.id)}>❌</button>
            </div>
            )   
      })}
    </div>
  )
}
